// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import type { Location } from 'react-router';
import type { CurrentUser } from 'api/currentUser';
import { showModal, hideModal } from '../redux/main/actions/modal';

type Props = {
  children: React.Node,
  currentUser: CurrentUser,
  location: Location,
  modal: Object,
  showModal: typeof showModal,
  hideModal: typeof hideModal
};

class ShowUserModals extends React.PureComponent<Props> {
  verify() {
    const { currentUser, modal } = this.props;

    const EMAIL_VERIFICATION_WHITELIST = ['/survey/start', '/survey/thank-you'];

    if (EMAIL_VERIFICATION_WHITELIST.includes(this.props.location.pathname)) {
      return;
    }

    const verifyEmail = !!currentUser.email && !currentUser.emailVerified;
    if (verifyEmail) {
      // INFORMATION_REQUIRED excepted for case of Facebook user not allowing
      // their email address and then has just filled one in.
      if (!modal.type || modal.type === 'INFORMATION_REQUIRED') {
        // only show the modal if another isn't already shown
        this.props.showModal('VERIFY_EMAIL');
      }
      return;
    }
    if (modal.type === 'VERIFY_EMAIL') {
      this.props.hideModal();
    }

    const informationRequired =
      currentUser.id &&
      (!currentUser.firstName || !currentUser.lastName || !currentUser.email) &&
      this.props.location.pathname !== '/dashboard';

    if (informationRequired) {
      if (!modal.type) {
        // only show the modal if another isn't already shown
        this.props.showModal('INFORMATION_REQUIRED');
      }
      return;
    }

    if (modal.type === 'INFORMATION_REQUIRED') {
      this.props.hideModal();
    }

    if (this.props.currentUser.showNotifPrefModal) {
      if (!modal.type) {
        // only show the modal if another isn't already shown
        this.props.showModal('NOTIFICATION_PREFERENCES');
      }
      return;
    }
    if (modal.type === 'NOTIFICATION_PREFERENCES') {
      this.props.hideModal();
    }
  }

  componentDidMount() {
    this.verify();
  }

  componentDidUpdate() {
    this.verify();
  }

  render() {
    return this.props.children;
  }
}

const mapStateToProps = ({ currentUser, modal }) => ({ currentUser, modal });

export default withRouter(
  connect(
    mapStateToProps,
    { showModal, hideModal }
  )(ShowUserModals)
);
